<template>
    <component :is="layout" id="app" />
</template>

<script>
import Auth from '@/layouts/Auth'
import Base from '@/layouts/Base'
import Static from '@/layouts/Static'

export default {
    computed: {
        layout() {
            if (this.$route.name === 'offer') {
                return Static
            }

            if (this.$store.getters['auth/isAuth'] === false) {
                return Auth
            }

            return Base
        }
    },

    mounted() {
        window.addEventListener('resize', () => this.setIsMobile())
        this.setIsMobile()
        this.applyMaxHeight()
    },

    async created() {
        if (this.$store.getters['company/suspended']) {
            this.$router.push({ name: 'suspend' })
        }
    },

    methods: {
        setIsMobile() {
            if (!this.$store.state.isMobile && window.innerWidth <= this.$store.state.toMobileWidth) {
                this.$store.commit('isMobile', true)
            } else if (this.$store.state.isMobile && window.innerWidth > this.$store.state.toMobileWidth) {
                this.$store.commit('isMobile', false)
            }
        },

        applyMaxHeight() {
            document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`)
        }
    }
}
</script>

<style lang="scss">
@import "scss/index.scss";
</style>
